import { BeforeInstallPromptEvent, usePwaStore,  } from "../store";

type BeforeInstallPromptHandler = (e: Event) => void;

export const handleBeforeInstallPrompt = (e: Event) => {
  e.preventDefault();
  const event = e as BeforeInstallPromptEvent;
  usePwaStore.getState().setPrompt(event);
};

export const registerBeforeInstallPrompt = (handler: BeforeInstallPromptHandler) => {
  window.addEventListener('beforeinstallprompt', handler);

  const hot = (import.meta as any)?.hot || (module as any)?.hot;
  if (hot?.dispose) {
    hot.dispose(() => {
      window.removeEventListener('beforeinstallprompt', handler);
    });
  }
};
